import * as React from 'react';
import { useEffect } from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { useTheme, useMediaQuery } from '@mui/material';

export default function CommonModal({ modalOpen, setModalOpen, children, onclose = true, modalWidth = false }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: isMobile ? '90vw' : isTablet ? '80vw' : modalWidth ? modalWidth : 700,
    maxWidth: '90vw',
    maxHeight: '90vh',
    bgcolor: 'background.paper',
    borderRadius: '8px',
    boxShadow: 24,
    p: isMobile ? 2 : 4,
    overflow: 'auto',
    '&:focus': {
      outline: 'none',
    },
  };

  useEffect(() => {
    if (modalOpen) {
      // Add class to body
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }

    return () => {
      document.body.classList.remove('modal-open');
    };
  }, [modalOpen]);

  return (
    <Modal
      open={modalOpen}
      onClose={() => {
        if (onclose) {
          setModalOpen(false);
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        backdropFilter: 'blur(2px)',
      }}
      disableScrollLock={true}
    >
      <Box sx={style}>
        {children}
      </Box>
    </Modal>
  );
}